import { useCallback, useSyncExternalStore } from 'react'

import type { FullTransactionPayload } from '@ankor-io/common/types/transaction/transaction'

// Simple module-level store (no browser storage) to persist transaction during SPA lifetime
let currentTransaction: FullTransactionPayload | null = null
const listeners = new Set<() => void>()

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const getSnapshot = () => currentTransaction

const setStoreTransaction = (value: FullTransactionPayload | null) => {
  currentTransaction = value
  listeners.forEach((listener) => listener())
}

export const useTransaction = () => {
  const transaction = useSyncExternalStore(subscribe, getSnapshot)

  const setTransaction = useCallback((value: FullTransactionPayload | null) => {
    setStoreTransaction(value)
  }, [])

  return { transaction, setTransaction }
}
